<template>
  <div>
    <div class="sub-header">
      <h2>انتخاب خودرو ثبت شده</h2>
    </div>
    <div v-if="!loading">
      <div class=" error-message" v-if="errorMessage">
        {{ errorMessage }}
      </div>
      <div v-if="!errorMessage">
        <div v-if="!loading && getUserCars.length > 0">
          <h3 class="select-car-title text-color">
            برای گرفتن استعلام، خودرو مورد نظر خود را از لیست زیر انتخاب و بر روی آن کلیک کنید:
          </h3>
          <div v-for="item in getUserCars" :key="item.id">
            <userCar :carId="item.id" :type="redirect" :redirect="redirect" />
          </div>
        </div>
        <div v-if="!loading && getUserCars.length == 0">
          <div class="page pad40t">
            <div class="custom-box">
              <div style="padding-bottom: 40px;">
                <span class="icon-box">
                  <i class="far fa-car"></i>
                </span>
              </div>
              <div>
                <div class="textCenter mar5b">
                  خودرویی در حساب کاربری شما پارک نشده است. برای پارک خودرو در
                  قسمت "پروفایل" خودرو خود را ثبت کنید.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-box add-car">
          <div>
            <div class="mar5b">
              <h3 class="header-box">استعلام سریع برای خود و یا شخص دیگر</h3>
              <div v-if="redirect == 'violation-inquiry'" class="custom-box-text">
                 با استعلام جزئیات خلافی خودرو می‌توانید از محل و تاریخ وقوع خلافی مطلع شده و نسبت به پرداخت هر کدام اقدام نمائید. برای استفاده از این سرویس کافی است شماره پلاک، کد ملی و تلفن همراه مالک خودرو را وارد کنید. هزینه استعلام خلافی 5,200 تومان است. 
              </div>
              <div v-else-if="redirect == 'violation-inquiry-all'" class="custom-box-text">
               با استعلام تجمیع خلافی خودرو می‌توانید مجموع هزینه خلافی خودرو را یکجا مشاهده کنید. برای استفاده از این سرویس کافی است شماره پلاک، تلفن همراه مالک و کد ملی مالک خودرو را وارد کنید. هزینه استعلام خلافی 5,200 تومان است. 
              </div>
              <div v-else-if="redirect == 'card-sanad-inquiry'" class="custom-box-text">
                با استعلام وضعیت کارت و سند خودرو می‌توانید جزئیات مربوط به اسناد خودرو خود را دریافت کنید. برای استفاده از این سرویس کافی است اطلاعات زیر را وارد کنید. هزینه استعلام خلافی 5200 تومان است. 
              </div>
              <input
                type="text"
                class="input"
                v-model="NationalityCodeInput"
                placeholder="کد ملی مالک خودرو"
                maxlength="10"
                @keypress="isNumber($event)"
              />
              <input
                type="text"
                class="input"
                v-model="MobileInput"
                placeholder="تلفن همراه مالک خودرو"
                maxlength="11"
                @keypress="isNumber($event)"
              />
              <div class="plate">
                <input type="plate" maxlength="2" placeholder="" value=""
                  style="margin-left: 5px; width: 39px; margin-right: 15px;" v-model="IranDigits">
                <input type="plate" maxlength="3" placeholder="" value=""
                  style="margin-left: 10px; width: 58px; margin-right: 13px;" v-model="ThreeDigits">
                <select id="letter" v-model="Alphabet">
                  <option v-for="item in AlphabetItem" v-bind:key="item.id">
                  <option>{{item}}</option>
                  </option>
                </select>
                <input type="plate" maxlength="2" placeholder="" value="" style="margin-right: 10px; width: 39px"
                  v-model="FirstTwoDigits">
              </div>
              <input
                v-if="this.CodeFlag"
                type="text"
                class="input"
                v-model="Code"
                placeholder="کد ارسال شده به تلفن همراه"
                maxlength="5"
                @keypress="isNumber($event)"
              />
              <span v-if="this.NationalityCodeActive == true && this.MobileActive == true">
                <span v-if="this.userMobile == this.newCar[0]">
                  <router-link class="input primary-btn" :to="`/inquiry/${redirect}/0/${newCar}`">استعلام</router-link>  
                </span>
                <span v-else-if="this.userMobile != this.newCar[0] && !this.Code">
                  <a class="input primary-btn" @click="getInquiry">استعلام</a>
                </span>
                <span v-else-if="this.userMobile != this.newCar[0] && this.Code">
                  <router-link class="input primary-btn" :to="`/inquiry/${redirect}/0/${newCar}`">استعلام</router-link>  
                </span>
              </span>
              <span v-else>
                <div class="input primary-btn deactive">استعلام</div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader v-if="loading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "../../service";
import loader from "../../components/inquiry/Loader";
import userCar from "../../components/inquiry/UserCar";

export default {
  name: "select-car",
  components: {
    loader,
    userCar,
  },
  props: {
    redirect: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions(["setUserCars", "setTheme", "setToken"]),
    isNumber: function(e) {
      var iKeyCode = e.which ? e.which : e.keyCode;
      if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
        e.preventDefault();
      return true;
    },
    getInquiry() {
      this.CodeFlag = true;
      api
          .getSendOtp(
            this.newCar[0]
          )
          .then((response) => {
            if (response.data && response.data.status === 200) {
             this.errorMessage = response.data.messages[0];
            } else {
              if (
                response.data &&
                response.data.messages &&
                response.data.messages.length > 0
              ) {
                this.errorMessage = response.data.messages[0];
              }
            }
          })
          .catch((err) => {
            this.errorMessage =
              "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
            this.errorMessage = err.response.data.messages[0];
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  computed: {
    ...mapGetters(["getUserCars"]),
  },
  data() {
    return {
      errorMessage: null,
      loading: false,
      AlphabetItem: [],
      newCar: [],
      NationalityCodeInput: '',
      MobileInput: '',
      IranDigits: '',
      ThreeDigits: '',
      Alphabet: '',
      FirstTwoDigits: '',
      Code: '',
      NationalityCodeActive: false,
      MobileActive: false,
      CodeFlag: false,
      userMobile: '',
    };
  },
  mounted() {
    if (this.$route.query.theme == "dark") {
      this.setTheme("dark");
    }
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token);
    }

    api
      .getUserInformation()
      .then((response) => {
        if (response.data && response.data.status === 200) {
          this.userMobile = response.data.data.mobile;
          //console.log(response.data.data);
        } else {
          if (
            response.data &&
            response.data.Messages &&
            response.data.Messages.length > 0
          ) {
            this.errorMessage = response.data.Messages[0];
          }
        }
      })
      .catch(() => {
        this.errorMessage =
          "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
      })
      .finally(() => {
        this.loading = false;
      });

    this.loading = true;
    api
      .getUserCars()
      .then((response) => {
        this.setUserCars(response.data.data);
      })
      .catch(() => {
        this.errorMessage =
          "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
      })
      .finally(() => {
        this.loading = false;
      });

      api
        .getPlateAlphabet()
        .then((response) => {
          if (response.data && response.data.status === 200) {
            this.AlphabetItem = response.data.data;
            //console.log(this.AlphabetItem);
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch(() => {
          this.errorMessage = "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        })
        .finally(() => {
          this.loading = false;
        });
  },
  watch: {
    MobileInput(item) {
      if(item){
        this.MobileActive = true;
      }else{
        this.MobileActive = false;
      }
      this.newCar[0] = item
    },
    NationalityCodeInput(item) {
      if(item){
        this.NationalityCodeActive = true;
      }else{
        this.NationalityCodeActive = false;
      }
      this.newCar[1] = item
    },
    IranDigits(item) {
      this.newCar[2] = item
    },
    ThreeDigits(item) {
      this.newCar[3] = item
    },
    Alphabet(item) {
      this.newCar[4] = item
    },
    FirstTwoDigits(item) {
      this.newCar[5] = item
    },
    Code(item) {
      this.newCar[6] = item
    },
  },
};
</script>

<style scoped>
.select-car-title {
  padding: 20px 12px 8px 12px;
}
.header-box {
  background: #bb133e;
  padding: 20px 10px;
  text-align: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  color: #fff;
  font-size: 18px;
}
.custom-box.add-car {
  padding: 0 0 15px;
  margin-top: 40px;
}
.plate {
  background-image: url(../../../src/assets/img/img_empty_plate.png);
  display: flex;
  width: 276px;
  background-repeat: no-repeat;
  background-position: center;
  align-items: center;
  min-height: 60px;
  direction: rtl;
  margin: 5px auto 10px;
  font-size: 26px;
  background-size: cover;
}
.plate > div {
  margin: 0 auto;
  font-family: nazanin;
}
.plate input {
  padding: 0 !important;
  width: 24px;
  padding: 5px 0 !important;
  text-align: center;
  font-size: 16px;
  margin: 1px 2px 0;
  background: #fff !important;
  border: 1px solid #ccc;
  height: 25px;
}
.plate select#letter {
  padding: 0 !important;
  height: 100%;
  width: 44px;
  margin: 0px 2px;
}
</style>
